<template>
  <div id="stockFlowInventoryDetail">
    <div class="invoicingHead">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicing/stockCheck')" href="javascript:;">库存盘点</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>盘点单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="invoicingHeadDown">
      <!-- 进货退货单详情资料 -->
      <div class="goodsDetail">
        <div>盘点单详情</div>
        <div class="info">
          <div class="first" style="width: 20%">
            <div>单号：{{ list.orderCode }}</div>
            <div>业务日期：{{ list.businessTime }}</div>
            <div>仓库盘点：{{ list.repositoryName }}</div>
          </div>
          <div style="width: 50%; padding: 0 25px; box-sizing: border-box">
            <!-- <div>业务日期：{{list.businessTime}}</div> -->
            <div>经手人：{{ list.handlerName }}</div>
            <div>备注：{{ list.checkRemark ? list.checkRemark : "无" }}</div>
          </div>
          <!-- <div style="width: 40%">
                        <div>图片附件：</div>
                        <div>
                            <el-upload
                                action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove"
                                :http-request="loadImg"
                                :show-file-list = true
                                :file-list="fileList"
                                :before-upload="beforeAvatarUpload"
                                :class="{hide:hideUpload}"
                                :limit="3">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                              <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </div>
                    </div> -->
          <div style="width: 30%; padding-right: 20px; box-sizing: border-box">
            <el-button
              type="primary"
              size="small"
              v-if="isDestroy == 0"
              @click="destroyRefundGoods"
              >作废</el-button
            >
            <div
              v-if="isDestroy == 1"
              style="font-size: 20px; color: #000; font-weight: bold"
            >
              已作废
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            align="center"
            prop="goodsName"
            label="盘点商品"
            width="180"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="valueContent"
            label="规格"
          ></el-table-column>
          <el-table-column align="center" prop="bookNum" label="账面数量">
            <template slot-scope="scope"
              >{{ scope.row.bookNum }}{{ scope.row.goodsUnit }}</template
            >
          </el-table-column>
          <el-table-column align="center" prop="actualNum" label="实际数量">
            <template slot-scope="scope"
              >{{ scope.row.actualNum }}{{ scope.row.goodsUnit }}</template
            >
          </el-table-column>
          <el-table-column align="center" prop="checkStatus" label="状态">
            <template slot-scope="scope">
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #6abcf8;
                  margin: auto;
                  color: #6abcf8;
                  font-size: 10px;
                "
                v-if="scope.row.checkStatus == 0"
              >
                无盈亏
              </div>
              <div
                style="
                  width: 60px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 10px;
                  border: 1px solid #ccc;
                  margin: auto;
                  color: #ccc;
                  font-size: 10px;
                "
                v-if="scope.row.checkStatus == 1"
              >
                有盈亏
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="queryInfo.pageNum"
                    :page-size="queryInfo.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  ></el-pagination>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { uploadImg, singleGoodsCheckAll, destroyGoodsCheck } from "../api";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 999,
      },
      orderId: "",
      isDestroy: "",
      list: {
        orderCode: "",
        businessTime: "",
        handlerName: "",
        supplierName: "",
        repositoryName: "",
        otherFree: "",
        accountRefundPayable: "",
        refundRemark: "",
        settlementMethod: "",
        goodsName: "",
        totalTakePrice: "",
        takePrice: "",
        checkRemark: "",
      },
      totalLength: 0,
      fileList: [],
      hideUpload: false,
    };
  },
  created() {
    this.orderId = sessionStorage.getItem("detailOrderid");
    this.getSingleReturnGoodsList();
    this.hideUpload = true;
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 图片放大
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 上传商品图片
    loadImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm)
        .then((res) => {
          console.log(res);
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogImageUrl = res.data.url;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {});
    },
    // 获取退货进货单详情列表
    getSingleReturnGoodsList() {
      singleGoodsCheckAll({
        isManager: 1,
        pageNo: this.queryInfo.pageNum,
        row: this.queryInfo.pageSize,
        orderId: this.orderId,
      }).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.productJson;
          this.list = res.data;
          this.isDestroy = res.data.isDestroy;
          this.tableData.forEach((element) => {
            this.fileList.unshift({ name: "", url: element.goodsImage });
          });
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分页
    // handleCurrentChange(newVal) {

    // },
    // handleSizeChange(newVal) {

    // }
    // 作废
    destroyRefundGoods() {
      this.$confirm("是否确定作废", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          destroyGoodsCheck({
            isManager: 1,
            orderId: this.orderId,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success("已提交待审核");
              this.$router.push("/invoicing/stockCheck");
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.flex-betweens {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.flex-between {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flex-between:last-child {
  text-align: right;
}
.mb5 {
  margin-bottom: 5px;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.dottedLine {
  border: 1px dotted #ccc;
  margin-top: 5px;
}
.dashedLine {
  border: 1px dashed #ccc;
  margin-top: 5px;
}
.line {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  top: 111px;
}
.lines {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  left: 195px;
  top: 111px;
}
.shopName {
  font-size: 18px;
  text-align: center;
  color: #000;
}
.voucherTitle {
  padding-top: 15px;
  font-size: 18px;
}
.goodsDetail {
  width: 100%;
  height: auto;
  background-color: #f8f8f8;
  padding: 20px;
}
.info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #737373;
}
.title {
  width: calc(100vw - 245px);
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
  background-color: #f8f8f8;
  font-size: 15px;
  padding-left: 20px;
  box-sizing: border-box;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
  margin-top: 20px;
}
</style>
